import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { Tabs } from '@udemy-v2/react-structure-components';
import { useClpPurchaseContext } from '../../context/clp-purchase-context.react-component';
import styles from './course-sidebar-tabs-container.module.scss';
import { publishEvent } from '@udemy-v2/event-tracking';
import { ClickEvent, LearningProduct } from '../../events/events';
import { useClpCourse } from '../../context/clp-course-provider.react-component';
import { CourseContentPlacement } from '@/features/course-landing-page/course-landing-page.react-component';
import { useI18n } from '@udemy-v2/i18n';
import { observer } from 'mobx-react';
export enum SidebarTabType {
  PERSONAL = 'personal',
  TEAMS = 'teams',
}
interface CourseSidebarTabsContainerProps {
  personalContent: React.ReactNode;
  teamsContent: React.ReactNode;
  placement: CourseContentPlacement;
}

/**
 * Internal component for CourseSidebarTabsContainer
 */
function CourseSidebarTabsContainerInternal(t0) {
  const $ = _c(22);
  const {
    personalContent,
    teamsContent,
    placement
  } = t0;
  const {
    activeSidebarTab,
    setActiveSidebarTab
  } = useClpPurchaseContext();
  const [hasClickedTeamsTab, setHasClickedTeamsTab] = useState(false);
  const course = useClpCourse();
  const {
    gettext
  } = useI18n();
  let t1;
  if ($[0] !== course || $[1] !== hasClickedTeamsTab || $[2] !== setActiveSidebarTab) {
    t1 = tabId => {
      setActiveSidebarTab(tabId as SidebarTabType);
      if (tabId === SidebarTabType.TEAMS && !hasClickedTeamsTab) {
        publishEvent(new ClickEvent({
          componentName: "TeamsPurchaseContent",
          trackingId: course.id,
          relatedObjectType: LearningProduct.COURSE,
          relatedObjectId: Number(course.id)
        }));
        setHasClickedTeamsTab(true);
      }
    };
    $[0] = course;
    $[1] = hasClickedTeamsTab;
    $[2] = setActiveSidebarTab;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleTabSelect = t1;
  let t2;
  if ($[4] !== gettext) {
    t2 = gettext("Personal");
    $[4] = gettext;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== personalContent || $[7] !== t2) {
    t3 = <Tabs.Tab id={SidebarTabType.PERSONAL} title={t2}>{personalContent}</Tabs.Tab>;
    $[6] = personalContent;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== gettext) {
    t4 = gettext("Teams");
    $[9] = gettext;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = placement === CourseContentPlacement.SIDEBAR ? styles["sidebar-teams-tab-container"] : "";
  let t6;
  if ($[11] !== t5 || $[12] !== teamsContent) {
    t6 = <div className={t5}>{teamsContent}</div>;
    $[11] = t5;
    $[12] = teamsContent;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <Tabs.Tab id={SidebarTabType.TEAMS} title={t4}>{t6}</Tabs.Tab>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== activeSidebarTab || $[18] !== handleTabSelect || $[19] !== t3 || $[20] !== t7) {
    t8 = <Tabs activeTabId={activeSidebarTab} onSelect={handleTabSelect} fullWidth={true}>{t3}{t7}</Tabs>;
    $[17] = activeSidebarTab;
    $[18] = handleTabSelect;
    $[19] = t3;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
export const CourseSidebarTabsContainer = observer(CourseSidebarTabsContainerInternal);